import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";
import ReadonlyFeeScheduleCategoriesTable from "_shared/fee-schedules/categories/_views/readonly-fee-schedule-categories-table";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { FeeScheduleCategoryMaskedCurrency, Masked } from "work/_shared/masked-fields";
import WorkAgreement from "work/work-agreements/work-agreement";

const ListContainer = styled(Grid)(
  () => ({
    minHeight: "20rem",
  }));
const CategorySelection = styled(ReadonlyFeeScheduleCategoriesTable)(
  ({ theme }) => ({
    [theme.breakpoints.down("lg")]: {
      marginTop: theme.spacing(2),
    },
    height: "100%",
    marginLeft: theme.spacing(2),
  }));

type FeeScheduleTabProps = {
  workAgreement: WorkAgreement;
};

export default function FeeScheduleTab(
  props: Readonly<FeeScheduleTabProps>
) {
  const {
    workAgreement
  } = props;

  let selectedCategories: FeeScheduleCategory | FeeScheduleCategoryMaskedCurrency[] = [];
  if (Masked.isNotMasked(workAgreement.feeSchedule)) {
    selectedCategories = workAgreement.feeSchedule;
  }

  return (
    <ListContainer container direction="row">
      <Grid size="grow">
        <CategorySelection
          categories={selectedCategories}
          hideCommentButton={true}
        />
      </Grid>
    </ListContainer>
  );
}
